export const sharingUsers = [
  {
    'uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'first_name': 'رضا',
    'last_name': 'کیانی',
    'phone': '989190000000',
    'test_created_at': 1630483397,
    'label': 'yellow'
  },
  {
    'uuid': 'dc035d80-1d2d-4e78-85d7-b72a72f7cd76',
    'first_name': 'احمد',
    'last_name': 'سرابی',
    'phone': '989191111111',
    'test_created_at': 1627804997,
    'label': 'green'
  },
  {
    'uuid': '651df9ab-6007-4265-950b-385231857b2b',
    'first_name': 'سید علی',
    'last_name': 'حسینی',
    'phone': '989192222222',
    'test_created_at': 1629014597,
    'label': 'red'
  },
  {
    'uuid': '2676361a-3113-4eb7-8fda-0231f8f5ca23',
    'first_name': 'مهدی',
    'last_name': 'طاهرپور کلانتری',
    'phone': '989193333333',
    'test_created_at': 1629619397,
    'label': 'green'
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/sharing-users.js